// extracted by mini-css-extract-plugin
export default {"pay_button":"PayButton_pay_button__l56nl","loader":"PayButton_loader__1ZGNk","rotation":"PayButton_rotation__kXKnX"};